<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="COD回款导入" name="first">
        <FeeImportCOD v-if="activeName=='first'"></FeeImportCOD>
      </el-tab-pane>
      <el-tab-pane label="店铺回款导入" name="second">
        <FeeImportCOD1 v-if="activeName=='second'"></FeeImportCOD1>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FeeImportCOD from './FeeImportCOD/FeeImportCOD'
import FeeImportCOD1 from './FeeImportCOD1/FeeImportCOD1'
export default {
  name: 'RefundImport',
  components: {
    FeeImportCOD,
    FeeImportCOD1
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>
